import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CookiesConsentManager } from '@deliveroo/cookies-consent';
import { getCookiesConsentMode } from '../../../utils/cookies/helpers';
import sentry from '../../../utils/sentry';

const { captureException } = sentry();

const CookieConsent = ({ tld, locale }) => {
  const scriptSrc = CookiesConsentManager.getCookiesConsentScript(
    tld,
    locale,
    getCookiesConsentMode(),
  );

  if (!scriptSrc) {
    if (scriptSrc !== null) {
      // scriptSrc is intentionally `null` if the
      // cookieConsentMode is NOOP (i.e. for local dev)
      captureException(new Error(`Cookie consent error: OneTrust not configured for TLD "${tld}"`));
    }

    return null;
  }

  return (
    <Fragment>
      <script src={scriptSrc} type="text/javascript" charSet="UTF-8" />
    </Fragment>
  );
};

CookieConsent.propTypes = {
  tld: PropTypes.string,
  locale: PropTypes.string,
};

CookieConsent.defaultProps = {
  tld: undefined,
  locale: undefined,
};

export default CookieConsent;
